import React, { FC } from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const Homepage: FC = () => (
  <NavigationLayout dataApp='homepage'>
    <Layout />
  </NavigationLayout>
)

export default Homepage
